import { IProgrammeCard } from '@studyportals/domain-client';

export class PresentationStudyCardInfo {
	public constructor(
		public readonly id: string,
		public card: IProgrammeCard,
		public readonly enhanced: boolean,
		public readonly order: number,
		public readonly canShowIUDiscountInfo: boolean
	) {}
}
